var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33203 10.8359H7.66536V6.83594H6.33203V10.8359ZM6.9987 0.835938C3.31536 0.835938 0.332031 3.81927 0.332031 7.5026C0.332031 11.1859 3.31536 14.1693 6.9987 14.1693C10.682 14.1693 13.6654 11.1859 13.6654 7.5026C13.6654 3.81927 10.682 0.835938 6.9987 0.835938ZM6.9987 12.8359C4.0587 12.8359 1.66536 10.4426 1.66536 7.5026C1.66536 4.5626 4.0587 2.16927 6.9987 2.16927C9.9387 2.16927 12.332 4.5626 12.332 7.5026C12.332 10.4426 9.9387 12.8359 6.9987 12.8359ZM6.33203 5.5026H7.66536V4.16927H6.33203V5.5026Z",
    fill: "#F33A3A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.6daac0739eabbad57ea5882e888669e0.svg";
export { ForwardRef as ReactComponent };